<template>
  <nv-model
    :id="id"
    :prev="prev"
    :next="next"
    :info="info"
    :title="info.title"
    :initScale="0.5"
    @on-load="onImgLoad"
    @go="goImg"
  >
  </nv-model>
</template>

<script>
import NvModel from '../model'

export default {
  name: 'ModalPic',
  components: { NvModel },
  props: {
    id: Number,
    list: Array
  },
  data() {
    return {
      info: { src: '' },
      next: null, // 下一页
      prev: null // 上一页
    }
  },
  mounted() {
    let index = this.list.findIndex(l => +l.id === +this.id)
    this.$nextTick(() => this.goImg(index))
  },
  methods: {
    goImg(index) {
      this.info = this.list[index]
      this.next = +index > 0 ? index - 1 : -1
      this.prev = index + 1 < this.list.length ? index + 1 : -1
    },
    onImgLoad() {}
  }
}
</script>

<style media="screen">
.model-insect {
  position: absolute;
  border: 2px solid rgb(64, 158, 255);
}
.model-insect__name {
  font-size: 14px;
  position: absolute;
  white-space: nowrap;
  top: -20px;
  left: -4px;
}
</style>
